"use strict";
/**
 * In Tier II reports, a user must report the quantity of different chemicals
 * stored at their facilities. This may be in the form of putting in exact
 * amounts or it may be through the selection of "range codes". For some extra
 * fun, the range codes are _mostly_ the same across states, but there are some
 * exceptions.
 *
 * Source forked from previous application:
 *   https://github.com/Encamp/evergreen/blob/b529a8852054489c33049731d129a2b8a913fc22/_frontend_src/constants/amounts.js
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCodeByPercentage = exports.getAmountCodes = exports.getRangeCodeMaxima = exports.getRangeCodeMinima = exports.DensityUnits = exports.TIER_II_DENSITY_UNIT = exports.TIER_II_UNIT = exports.OREGON_AMOUNT_CODES_DISPLAY = exports.AMOUNT_CODE_FRACTION = void 0;
exports.getAmountCode = getAmountCode;
exports.getParsedAmountCodeOrNull = getParsedAmountCodeOrNull;
const AMOUNT_CODE_NUMBERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
const OREGON_AMOUNT_CODE_NUMBERS = [
    0, 1, 2, 3, 4, 10, 11, 20, 21, 30, 31, 40, 41, 42, 43, 50, 51, 52, 53, 60, 61, 70, 71, 80, 81, 90,
    91, 99,
];
const NEW_JERSEY_AMOUNT_CODE_NUMBERS = [
    9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
];
const AMOUNT_CODES_MINIMA = {
    1: 0,
    2: 100,
    3: 500,
    4: 1000,
    5: 5000,
    6: 10000,
    7: 25000,
    8: 50000,
    9: 75000,
    10: 100000,
    11: 500000,
    12: 1000000,
    13: 10000000,
};
exports.AMOUNT_CODE_FRACTION = 0.0001;
const AMOUNT_CODES_MAXIMA = {
    1: 100 - exports.AMOUNT_CODE_FRACTION,
    2: 500 - exports.AMOUNT_CODE_FRACTION,
    3: 1000 - exports.AMOUNT_CODE_FRACTION,
    4: 5000 - exports.AMOUNT_CODE_FRACTION,
    5: 10000 - exports.AMOUNT_CODE_FRACTION,
    6: 25000 - exports.AMOUNT_CODE_FRACTION,
    7: 50000 - exports.AMOUNT_CODE_FRACTION,
    8: 75000 - exports.AMOUNT_CODE_FRACTION,
    9: 100000 - exports.AMOUNT_CODE_FRACTION,
    10: 500000 - exports.AMOUNT_CODE_FRACTION,
    11: 1000000 - exports.AMOUNT_CODE_FRACTION,
    12: 10000000 - exports.AMOUNT_CODE_FRACTION,
    13: Infinity,
};
const OREGON_AMOUNT_CODES_MINIMA = {
    0: 0,
    1: 5,
    2: 10,
    3: 20,
    4: 50,
    10: 200,
    11: 500,
    20: 1000,
    21: 5000,
    30: 10000,
    31: 50000,
    40: 100000,
    41: 250000,
    42: 500000,
    43: 750000,
    50: 1000000,
    51: 2500000,
    52: 5000000,
    53: 7500000,
    60: 10000000,
    61: 25000000,
    70: 50000000,
    71: 75000000,
    80: 100000000,
    81: 250000000,
    90: 500000000,
    91: 750000000,
    99: 1000000000,
};
const OREGON_AMOUNT_CODES_MAXIMA = {
    0: 5 - exports.AMOUNT_CODE_FRACTION,
    1: 10 - exports.AMOUNT_CODE_FRACTION,
    2: 20 - exports.AMOUNT_CODE_FRACTION,
    3: 50 - exports.AMOUNT_CODE_FRACTION,
    4: 200 - exports.AMOUNT_CODE_FRACTION,
    10: 500 - exports.AMOUNT_CODE_FRACTION,
    11: 1000 - exports.AMOUNT_CODE_FRACTION,
    20: 5000 - exports.AMOUNT_CODE_FRACTION,
    21: 10000 - exports.AMOUNT_CODE_FRACTION,
    30: 50000 - exports.AMOUNT_CODE_FRACTION,
    31: 100000 - exports.AMOUNT_CODE_FRACTION,
    40: 250000 - exports.AMOUNT_CODE_FRACTION,
    41: 500000 - exports.AMOUNT_CODE_FRACTION,
    42: 750000 - exports.AMOUNT_CODE_FRACTION,
    43: 1000000 - exports.AMOUNT_CODE_FRACTION,
    50: 2500000 - exports.AMOUNT_CODE_FRACTION,
    51: 5000000 - exports.AMOUNT_CODE_FRACTION,
    52: 7500000 - exports.AMOUNT_CODE_FRACTION,
    53: 10000000 - exports.AMOUNT_CODE_FRACTION,
    60: 25000000 - exports.AMOUNT_CODE_FRACTION,
    61: 50000000 - exports.AMOUNT_CODE_FRACTION,
    70: 75000000 - exports.AMOUNT_CODE_FRACTION,
    71: 100000000 - exports.AMOUNT_CODE_FRACTION,
    80: 250000000 - exports.AMOUNT_CODE_FRACTION,
    81: 500000000 - exports.AMOUNT_CODE_FRACTION,
    90: 750000000 - exports.AMOUNT_CODE_FRACTION,
    91: 1000000000 - exports.AMOUNT_CODE_FRACTION,
    99: Infinity,
};
const NEW_JERSEY_AMOUNT_CODES_MINIMA = {
    9: 1,
    10: 10,
    11: 100,
    12: 500,
    13: 1000,
    14: 2500,
    15: 5000,
    16: 10000,
    17: 25000,
    18: 50000,
    19: 100000,
    20: 500000,
    21: 1000000,
    22: 10000000,
};
const NEW_JERSEY_AMOUNT_CODES_MAXIMA = {
    9: 10 - exports.AMOUNT_CODE_FRACTION,
    10: 100 - exports.AMOUNT_CODE_FRACTION,
    11: 500 - exports.AMOUNT_CODE_FRACTION,
    12: 1000 - exports.AMOUNT_CODE_FRACTION,
    13: 2500 - exports.AMOUNT_CODE_FRACTION,
    14: 5000 - exports.AMOUNT_CODE_FRACTION,
    15: 10000 - exports.AMOUNT_CODE_FRACTION,
    16: 25000 - exports.AMOUNT_CODE_FRACTION,
    17: 50000 - exports.AMOUNT_CODE_FRACTION,
    18: 100000 - exports.AMOUNT_CODE_FRACTION,
    19: 500000 - exports.AMOUNT_CODE_FRACTION,
    20: 1000000 - exports.AMOUNT_CODE_FRACTION,
    21: 10000000 - exports.AMOUNT_CODE_FRACTION,
    22: Infinity,
};
const AMOUNT_CODES_DISPLAY = {
    "1": "[01] 0-99",
    "2": "[02] 100-499",
    "3": "[03] 500-999",
    "4": "[04] 1,000-4,999",
    "5": "[05] 5,000-9,999",
    "6": "[06] 10,000-24,999",
    "7": "[07] 25,000-49,999",
    "8": "[08] 50,000-74,999",
    "9": "[09] 75,000-99,999",
    "10": "[10] 100,000-499,999",
    "11": "[11] 500,000-999,999",
    "12": "[12] 1,000,000-9,999,999",
    "13": "[13] 10,000,000+",
};
exports.OREGON_AMOUNT_CODES_DISPLAY = {
    "0": "[00] 0-4",
    "1": "[01] 5-9",
    "2": "[02] 10-19",
    "3": "[03] 20-49",
    "4": "[04] 50-199",
    "10": "[10] 200-499",
    "11": "[11] 500-999",
    "20": "[20] 1,000-4,999",
    "21": "[21] 5,000-9,999",
    "30": "[30] 10,000-49,999",
    "31": "[31] 50,000-99,999",
    "40": "[40] 100,000-249,999",
    "41": "[41] 250,000-499,999",
    "42": "[42] 500,000-749,999",
    "43": "[43] 750,000-999,999",
    "50": "[50] 1,000,000-2,499,999",
    "51": "[51] 2,500,000-4,999,999",
    "52": "[52] 5,000,000-7,499,999",
    "53": "[53] 7,500,000-9,999,999",
    "60": "[60] 10,000,000-24,999,999",
    "61": "[61] 25,000,000-49,999,999",
    "70": "[70] 50,000,000-74,999,999",
    "71": "[71] 75,000,000-99,999,999",
    "80": "[80] 100,000,000-249,999,999",
    "81": "[81] 250,000,000-499,999,999",
    "90": "[90] 500,000,000-749,999,999",
    "91": "[91] 750,000,000-999,999,999",
    "99": "[99] 1,000,000,000-Greater than 1 Billion",
};
const NEW_JERSEY_AMOUNT_CODES_DISPLAY = {
    "9": "[09] 1-9",
    "10": "[10] 10-99",
    "11": "[11] 100-499",
    "12": "[12] 500-999",
    "13": "[13] 1,000-2,499",
    "14": "[14] 2,500-4,999",
    "15": "[15] 5,000-9,999",
    "16": "[16] 10,000-24,999",
    "17": "[17] 25,000-49,999",
    "18": "[18] 50,000-99,999",
    "19": "[19] 100,000-499,999",
    "20": "[20] 500,000-999,999",
    "21": "[21] 1,000,000-9,999,999",
    "22": "[22] 10 million or greater",
};
var TIER_II_UNIT;
(function (TIER_II_UNIT) {
    TIER_II_UNIT["POUNDS"] = "pounds";
    TIER_II_UNIT["GALLONS"] = "gallons";
    TIER_II_UNIT["CUBIC_FEET"] = "cubic feet";
    TIER_II_UNIT["TONS"] = "tons";
    TIER_II_UNIT["KILOGRAMS"] = "kilograms";
    TIER_II_UNIT["METRIC_TONS"] = "metric tons";
    TIER_II_UNIT["LITERS"] = "liters";
    TIER_II_UNIT["BARRELS"] = "barrels";
})(TIER_II_UNIT || (exports.TIER_II_UNIT = TIER_II_UNIT = {}));
var TIER_II_DENSITY_UNIT;
(function (TIER_II_DENSITY_UNIT) {
    TIER_II_DENSITY_UNIT["POUNDS_PER_CUBIC_FOOT"] = "pounds / cubic foot";
    TIER_II_DENSITY_UNIT["POUNDS_PER_GALLON"] = "pounds / gallon";
    TIER_II_DENSITY_UNIT["POUNDS_PER_LITERS"] = "pounds / liters";
    TIER_II_DENSITY_UNIT["POUNDS_PER_BARRELS"] = "pounds / barrels";
    TIER_II_DENSITY_UNIT["KILOGRAMS_PER_GALLON"] = "kilograms / gallons";
    TIER_II_DENSITY_UNIT["KILOGRAMS_PER_LITERS"] = "kilograms / liters";
    TIER_II_DENSITY_UNIT["KILOGRAMS_PER_CUBIC_FOOT"] = "kilograms / cubic feet";
    TIER_II_DENSITY_UNIT["KILOGRAMS_PER_BARRELS"] = "kilograms / barrels";
    TIER_II_DENSITY_UNIT["TONS_PER_GALLON"] = "tons / gallons";
    TIER_II_DENSITY_UNIT["TONS_PER_LITERS"] = "tons / liters";
    TIER_II_DENSITY_UNIT["TONS_PER_CUBIC_FOOT"] = "tons / cubic feet";
    TIER_II_DENSITY_UNIT["TONS_PER_BARRELS"] = "tons / barrels";
    TIER_II_DENSITY_UNIT["METRIC_TONS_PER_GALLON"] = "metric tons / gallons";
    TIER_II_DENSITY_UNIT["METRIC_TONS_PER_LITERS"] = "metric tons / liters";
    TIER_II_DENSITY_UNIT["METRIC_TONS_PER_CUBIC_FOOT"] = "metric tons / cubic feet";
    TIER_II_DENSITY_UNIT["METRIC_TONS_PER_BARRELS"] = "metric tons / barrels";
})(TIER_II_DENSITY_UNIT || (exports.TIER_II_DENSITY_UNIT = TIER_II_DENSITY_UNIT = {}));
exports.DensityUnits = [
    "pounds / cubic foot",
    "pounds / gallon",
    "pounds / liters",
    "pounds / barrels",
    "kilograms / gallons",
    "kilograms / liters",
    "kilograms / cubic feet",
    "kilograms / barrels",
    "tons / gallons",
    "tons / liters",
    "tons / cubic feet",
    "tons / barrels",
    "metric tons / gallons",
    "metric tons / liters",
    "metric tons / cubic feet",
    "metric tons / barrels",
];
function getAmountCode(amount, state) {
    // we want the largest amount code whose minimum is still less than or equal to
    //    our actual amount
    // 1. make a copy of the list so we don't reverse it in-place
    // 2. reverse so that when we do the below filter, the largest one will be first
    // 3. filter so that the only codes that remain are those whose min value is less
    //    than the amount, then take the first (largest) of these
    let code_numbers, code_minima;
    if (state === "OR") {
        code_numbers = OREGON_AMOUNT_CODE_NUMBERS;
        code_minima = OREGON_AMOUNT_CODES_MINIMA;
    }
    else if (state === "NJ") {
        code_numbers = NEW_JERSEY_AMOUNT_CODE_NUMBERS;
        code_minima = NEW_JERSEY_AMOUNT_CODES_MINIMA;
    }
    else {
        code_numbers = AMOUNT_CODE_NUMBERS;
        code_minima = AMOUNT_CODES_MINIMA;
    }
    let parsedAmount = typeof amount === "string" ? parseFloat(amount) : amount;
    if (parsedAmount < 1) {
        parsedAmount = 1;
    }
    return String([...code_numbers].reverse().find((code) => code_minima[code] <= parsedAmount));
}
function getParsedAmountCodeOrNull(amount, state) {
    if (!state) {
        return null;
    }
    else {
        const code = parseInt(getAmountCode(amount, state));
        return isNaN(code) ? null : code;
    }
}
const getRangeCodeMinima = (state, code) => {
    let amountCodeMinima;
    if (state === "NJ") {
        amountCodeMinima = NEW_JERSEY_AMOUNT_CODES_MINIMA[code];
    }
    else if (state === "OR") {
        amountCodeMinima = OREGON_AMOUNT_CODES_MINIMA[code];
    }
    else {
        amountCodeMinima = AMOUNT_CODES_MINIMA[code];
    }
    if (amountCodeMinima === undefined) {
        throw new Error(`No min value found for code ${code} in state ${state}`);
    }
    return amountCodeMinima;
};
exports.getRangeCodeMinima = getRangeCodeMinima;
const getRangeCodeMaxima = (state, code) => {
    let amountCodeMaxima;
    if (state === "NJ") {
        amountCodeMaxima = NEW_JERSEY_AMOUNT_CODES_MAXIMA[code];
    }
    else if (state === "OR") {
        amountCodeMaxima = OREGON_AMOUNT_CODES_MAXIMA[code];
    }
    else {
        amountCodeMaxima = AMOUNT_CODES_MAXIMA[code];
    }
    if (amountCodeMaxima === undefined) {
        throw new Error(`No max value found for code ${code} in state ${state}`);
    }
    return amountCodeMaxima;
};
exports.getRangeCodeMaxima = getRangeCodeMaxima;
const getAmountCodes = (state) => {
    switch (state) {
        case "NJ":
            return NEW_JERSEY_AMOUNT_CODES_DISPLAY;
        case "OR":
            return exports.OREGON_AMOUNT_CODES_DISPLAY;
        default:
            return AMOUNT_CODES_DISPLAY;
    }
};
exports.getAmountCodes = getAmountCodes;
const calculateCodeByPercentage = (state, code, percentage) => {
    const maxima = (0, exports.getRangeCodeMaxima)(state, code);
    return getAmountCode(Math.floor(((maxima - 1) * percentage) / 100), state);
};
exports.calculateCodeByPercentage = calculateCodeByPercentage;
//# sourceMappingURL=storageAmounts.js.map